//*ヘッダー設定のACODEでの戻りページ指定*//


if (sessionStorage.getItem('acode')=='rockin'){
   document.location = "/pages/rockin-blues";


} else if (sessionStorage.getItem('acode')=='seikima2'){
     document.location = "/pages/seikima2";

} else if (sessionStorage.getItem('acode')=='ego'){
     document.location = "/pages/ego";

} else if (sessionStorage.getItem('acode')=='yena'){
     document.location = "/pages/yena";
  
} else if (sessionStorage.getItem('acode')=='yuming'){
     document.location = "/pages/yuming";
  
} else if (sessionStorage.getItem('acode')=='Moritaka'){
     document.location = "/pages/Moritaka";

} else if (sessionStorage.getItem('acode')=='RSR'){
     document.location = "/pages/rsr-shop";

} else if (sessionStorage.getItem('acode')=='JUJU'){
     document.location = "/pages/JUJU";


} else if (sessionStorage.getItem('acode')=='miku'){
//     document.location = "/pages/mikusymphony";
     document.location = "/pages/mikusymphony2025";  
  
} else if (sessionStorage.getItem('acode')=='Sekai'){
//     document.location = "/pages/sekaisymphony";
     document.location = "/pages/sekaisymphony2024";  

} else if (sessionStorage.getItem('acode')=='SplitTour'){
     document.location = "/pages/SplitTour";  

} else if (sessionStorage.getItem('acode')=='Okamura'){
     document.location = "/pages/okamura";  

} else if (sessionStorage.getItem('acode')=='rsr-hikikae'){
     document.location = "/pages/rsr-hikikae"; 

} else if (sessionStorage.getItem('acode')=='MusiQuest'){
     document.location = "/pages/themusiquest";    

} else if (sessionStorage.getItem('acode')=='rsr-coleman'){
     document.location = "/pages/rsr-coleman"; 

} else if (sessionStorage.getItem('acode')=='j-wave'){
     document.location = "/pages/j-wave"; 

} else if (sessionStorage.getItem('acode')=='sweetloveshower'){
     document.location = "/pages/sweetloveshower"; 

} else if (sessionStorage.getItem('acode')=='PREDATORS'){
     document.location = "/pages/thepredators";   

} else if (sessionStorage.getItem('acode')=='TMJ'){
     document.location = "/pages/TMJ";     

} else if (sessionStorage.getItem('acode')=='DHC'){
     document.location = "/pages/DHC";

} else if (sessionStorage.getItem('acode')=='naeba'){
     document.location = "/pages/yuming_naebahikikae"; 
  
  } else if (sessionStorage.getItem('acode')=='NCIS'){
     document.location = "/pages/NCIS";  

  } else if (sessionStorage.getItem('acode')=='GGV'){
     document.location = "/pages/GGV";  

  } else if (sessionStorage.getItem('acode')=='TGJ'){
     document.location = "/pages/TGJ";  

  } else if (sessionStorage.getItem('acode')=='SMEX'){
     document.location = "/pages/SMEX";  

  } else if (sessionStorage.getItem('acode')=='OKAZ'){
     document.location = "/pages/OKAZ";

  } else if (sessionStorage.getItem('acode')=='KYKB'){
     document.location = "/pages/kiyokiba";

  } else if (sessionStorage.getItem('acode')=='8JAM'){
     document.location = "/pages/8jamfes";
  
  } else if (sessionStorage.getItem('acode')=='8JAM-hikikae'){
     document.location = "/pages/8jamfes-hikikae";

  } else if (sessionStorage.getItem('acode')=='INSTOKYO-hikikae'){
     document.location = "/pages/INSPIRETOKYO2024-hikikae";  

  } else if (sessionStorage.getItem('acode')=='CHIPPOKE'){
     document.location = "/pages/CHIPPOKE";  

  } else if (sessionStorage.getItem('acode')=='AquaTimez'){
     document.location = "/pages/aquatimez";    

  } else if (sessionStorage.getItem('acode')=='DoctorX'){
     document.location = "/pages/DoctorX";

  } else if (sessionStorage.getItem('acode')=='MARIKO'){
     document.location = "/pages/takahashi-mariko";

  } else if (sessionStorage.getItem('acode')=='ARATANI'){
     document.location = "/pages/ARATANI";

  } else if (sessionStorage.getItem('acode')=='AGASA'){
     document.location = "/pages/AGASA";

  } else if (sessionStorage.getItem('acode')=='SPOP'){
     document.location = "/pages/S-POPlive";

    } else if (sessionStorage.getItem('acode')=='ANTHEM'){
     document.location = "/pages/r-anthem";

  } else if (sessionStorage.getItem('acode')=='TGJ-hikikae'){
     document.location = "/pages/TGJ-hikikae";
  
    } else if (sessionStorage.getItem('acode')=='FUTOSHI'){
     document.location = "/pages/LittleParade";  

    } else if (sessionStorage.getItem('acode')=='KARIN'){
     document.location = "/pages/CARIN";

    } else if (sessionStorage.getItem('acode')=='50TA'){
     document.location = "/pages/50TA";  

    } else if (sessionStorage.getItem('acode')=='50TA-JIGO'){
     document.location = "/pages/50TA-GOODS";

    } else if (sessionStorage.getItem('acode')=='ANTHEM-JIGO'){
     document.location = "/pages/R-ANTHEM-GOODS"; 

    } else if (sessionStorage.getItem('acode')=='W800'){
     document.location = "/pages/W800"; 

    } else if (sessionStorage.getItem('acode')=='NANO'){
     document.location = "/pages/NANO-mugenfes";
  
    } else if (sessionStorage.getItem('acode')=='hosomichi'){
     document.location = "/pages/hosomichi";

    } else if (sessionStorage.getItem('acode')=='yyss'){
     document.location = "/pages/yy_ss";

    } else if (sessionStorage.getItem('acode')=='JINMIRAISAI'){
     document.location = "/pages/JINMIRAISAI";
  
    } else if (sessionStorage.getItem('acode')=='JINMIRAISAI-hikikae'){
     document.location = "/pages/JINMIRAISAI-hikikae"; 

    } else if (sessionStorage.getItem('acode')=='ALDIOUS'){
     document.location = "/pages/ALDIOUS";  

    } else if (sessionStorage.getItem('acode')=='MON7A'){
     document.location = "/pages/MON7A";
     
    } else if (sessionStorage.getItem('acode')=='GYAKUTEN'){
     document.location = "/pages/GYAKUTEN";

 } else if (sessionStorage.getItem('acode')=='TOHOKU-DAISAKUSEN'){
     document.location = "/pages/TOHOKU-DAISAKUSEN";

 } else if (sessionStorage.getItem('acode')=='GYAKUTEN-hikikae'){
     document.location = "/pages/GYAKUTEN-hikikae";

} else if (sessionStorage.getItem('acode')=='Soala'){
     document.location = "/pages/Soala";

} else if (sessionStorage.getItem('acode')=='MAKA-SUKAJUMP'){
     document.location = "/pages/maka-sukajump";

    } else if (sessionStorage.getItem('acode')=='emptei'){
     document.location = "/pages/emptei";
  
} else {
//自動ジャンプ先  

}
